
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hrac/[id]",
      function () {
        return require("private-next-pages/hrac/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hrac/[id]"])
      });
    }
  